module.exports = __webpack_public_path__ + "media/assets/People-4626f1a78c8cae33f3c67c58e9b77c70.svg";